import { Component } from '@angular/core';

@Component({
	selector: 'app-simple',
	templateUrl: './simple-layout.component.html',
})

export class SimpleLayoutComponent {}